import React from "react";
import { withRouter } from "react-router-dom";
import UnOrderedList from "./sidebar_ul";
import Lang from "../../lang";
import $ from "jquery";
import services from "../../services";

const listParam = [
    // {
    //     name: 'Entidades',
    //     src1: 'imgs/icon7.png',
    //     src2: 'imgs/icon7_active.png',
    //     type: 'entidades'
    // },
    {
        name: "Agenda Digital",
        src1: "imgs/icon3.png",
        src2: "imgs/icon3_active.png",
        type: "agenda",
        url: "/agenda_digital",
    },
     {
         name: 'Parcela',
         src1: 'imgs/icon1.png',
         src2: 'imgs/icon1_active.png',
         url: '/dashboard',
         type: 'parcelas',
         submenu: "parcelas"
     },
     {

         name: 'Vindima',
         src1: 'imgs/icon2.png',
         src2: 'imgs/icon2_active.png',
         type: 'vindima',
         url: "/vindima_Conta_de_Produtor",
         submenu: "vindima"
     },
     {
        name: "Instalações Vínicas",
        src1: "imgs/icon3.png",
        src2: "imgs/icon3_active.png",
        url: "/instalacaovinica",
        type: "instalacoesvinicas",
    },
    {
        name: "Conta corrente",
        src1: "imgs/icon3.png",
        src2: "imgs/icon3_active.png",
        type: "contacorrente",
        url: "/conta_corrente",
    },
    {
        name: "Certificação",
        src1: "imgs/icon3.png",
        src2: "imgs/icon3_active.png",
        type: "registo",
        url: "/registo",
    },
    
    {
        name: "Marcas",
        src1: "imgs/icon6.png",
        src2: "imgs/icon6_active.png",
        url: "/marcasPendentes",
        type: "marcas",
    },
    
    {
        name: "Rótulos",
        src1: "imgs/icon6.png",
        src2: "imgs/icon6_active.png",
        url: "/rotulos",
        type: "rotulos",
    },
    {
        name: "Selos",
        src1: "imgs/icon5.png",
        src2: "imgs/icon5_active.png",
        type: "selos",
        url: "/selos_pedidos",
    },
    {
        name: 'Fiscalização',
        src1: 'imgs/icon4.png',
        src2: 'imgs/icon4_active.png',
        type: 'fiscalizacao',
        url: "/fiscalizacao",
    },
    // {
    //     name: 'Convocatórias',
    //     src1: 'imgs/icon7.png',
    //     src2: 'imgs/icon7_active.png',
    //     url: '/schedule',
    //     type: 'agenda'
    // },
    // {
    //     name: 'Processos',
    //     src1: 'imgs/icon7.png',
    //     src2: 'imgs/icon7_active.png',
    //     type: 'processos'
    // },
    {
        name: 'Portal Geográfico',
        src1: 'imgs/icon7.png',
        src2: 'imgs/icon7_active.png',
        type: 'globo',
        url: '/portalviticultor',
        submenu: "Tesouraria"
    },
     {
         name: 'Área Financeira',
         src1: 'imgs/icon7.png',
         src2: 'imgs/icon7_active.png',
         type: 'tesouraria',
         url: '/revenue_receitas',
         submenu: "Tesouraria"
     },
    // {
    //     name: 'Estatisticas',
    //     src1: 'imgs/icon7.png',
    //     src2: 'imgs/icon7_active.png',
    //     type: 'estatisticas'
    // },
    {
        name: 'Administarion',
        src1: 'imgs/icon7.png',
        src2: 'imgs/icon7_active.png',
        url: '/user_list',
        type: 'admin',
        submenu: "Administration"
    },
    {
        name: 'HelpDesk',
        src1: 'imgs/icon13.png',
        src2: 'imgs/icon13_active.png',
        url: '/HelpDesk',
        type: 'HelpDesk',
        submenu: "HelpDesk"
    }
];

const submenus = {
    parcelas: [
        {
            name: "Ficha de Parcela",
            src1: "imgs/icon1.png",
            src2: "imgs/icon1_active.png",
            url: "/dashboard",
            type: "parcelas",
        },
        {
            name: "Boletim",
            src1: "imgs/icon1.png",
            src2: "imgs/icon1_active.png",
            url: "/boletim",
            type: "boletim",
        },
    ],
    Administration: [
        {
            name: "User",
            src1: "imgs/icon-new1.png",
            src2: "imgs/icon-new1-active.png",
            url: "/user_list",
            type: "user",
        },
        {
            name: "Group",
            src1: "imgs/icon-new4.png",
            src2: "imgs/icon-new4-active.png",
            url: "/admin_dashboard_groups",
            type: "users",
        },
        {
            name: "Audit",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "/admin_dashboard_audit",
            type: "auditing",
        },
        {
            name: "Estatuto",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "/admin_dashboard_estato",
            type: "auditing",
        },
        {
            name: "Estatutos de Entidade",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "/entity_rule_list",
            type: "auditing",
        },
    ],
    vindima: [
        {
            name: "Conta de Produtor",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "/vindima_Conta_de_Produtor",
            type: "auditing",
        },
        {
            name: "Autorização de Produção (AP)",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "/vindima_authorizacao",
            type: "auditing",
        },
        {
            name: "Registo de Entrada de Uvas (REU)",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "/vindima_registo",
            type: "auditing",
        },
        {
            name: "Declaração de Compra e produção (DCP)",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "/vindima_declaracao",
            type: "auditing",
        },
        {
            name: "Área de análise / report de informação",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "/vindima_report",
            type: "auditing",
        },
    ],
    Tesouraria: [
        {
            name: "Tesouraria",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "/revenue_receitas",
            type: "auditing",
        },
        {
            name: "Faturas",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "/revenue_faturas",
            type: "auditing",
        },
        {
            name: "Caixa",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "cashier",
            type: "auditing",
        },
        {
            name: "Gerfip",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "gerfip",
            type: "auditing",
        },
        {
            name: "Conta Geral",
            src1: "imgs/icon-new3.png",
            src2: "imgs/icon-new3-active.png",
            url: "general_account",
            type: "auditing",
        },
    ],
    Marcas: [
        {
            name: "Pedidos de Aprovação",
            src1: "imgs/icon1.png",
            src2: "imgs/icon1_active.png",
            url: "/Shubham",
            type: "parcelas",
        },
        {
            name: "Histórico de Pedidos",
            src1: "imgs/icon1.png",
            src2: "imgs/icon1_active.png",
            url: "/boletim",
            type: "boletim",
        },
        {
            name: "Lista Marcas",
            src1: "imgs/icon1.png",
            src2: "imgs/icon1_active.png",
            url: "/boletim",
            type: "boletim",
        },
    ],
};

class LeftSideBar extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = { subMenuDisplay: {} };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        let url = window.location.pathname;
        window.localStorage.setItem("nav_bar", url);

        // Scroll to bottom div
        $(".show-more-menu").click(function () {
            $(".MyScrollDiv").animate(
                { scrollTop: $(document).height() },
                "slow"
            );
            return false;
        });

        // Remove Class on Scroll
        var header = $(".sidebar_shift.min-height .MyScrollDiv ");
        $(".sidebar_shift.min-height .MyScrollDiv ").scroll(function () {
            var scroll = $(this).scrollTop();
            if (scroll >= 120) {
                $(this).removeClass("excerpt-hidden");
            } else {
                $(this).addClass("excerpt-hidden");
            }
        });
    }
    goBack() {
        this.props.history.push({
            pathname: "/dashboard",
        });
    }

    mouseHover = (key) => {
        let subMenuDisplay = { ...this.state.subMenuDisplay };
        Object.keys(subMenuDisplay).map((_k) => {
            subMenuDisplay[_k] = false;
        });
        subMenuDisplay[key] = true;
        this.setState({ subMenuDisplay });
    };
    mouseLeave = () => {
        let subMenuDisplay = { ...this.state.subMenuDisplay };
        Object.keys(subMenuDisplay).map((_k) => {
            subMenuDisplay[_k] = false;
        });
        this.setState({ subMenuDisplay });
    };

    refreshComponent = () => {
        if (this.props.refreshComponent) {
            this.props.refreshComponent();
        }
    };

    render() {
        return (
            <div
                className="sidebar_shift"
                onMouseLeave={() => this.mouseLeave()}
            >
                <span className="mobile-expend cursor-pointer">
                    <i className="fas fa-chevron-right"></i>
                </span>
                <img
                    className="logo cursor-pointer"
                    onClick={() => services.goto.onto("/agenda_digital")}
                    src="/imgs/rddLogo.svg"
                    alt="RDD+"
                />

                <ul className="list-unstyled nav MyScrollDiv" role="tablist">
                    {listParam.map((list, index) => (
                        <UnOrderedList
                            refreshComponent={() => this.refreshComponent()}
                            mouseHover={(keys) => this.mouseHover(keys)}
                            mouseLeave={() => this.mouseLeave()}
                            subMenuDisplay={this.state.subMenuDisplay}
                            key={index}
                            index={index}
                            submenus={submenus}
                            name={Lang.langCheck.langRequest(`${list.name}`)}
                            linkdata={list}
                        />
                    ))}
                    <li
                        onMouseEnter={() =>
                            this.mouseHover(listParam.length + 1)
                        }
                        style={{ backgroundColor: "#fff" }}
                    >
                        &nbsp;
                    </li>
                </ul>
                <span className="show-more-menu cursor-pointer toggle-menu">
                    <i className="fas fa-chevron-down text-white"></i>
                </span>
            </div>
        );
    }
}

export default withRouter(LeftSideBar);
